import { Component } from '@angular/core';
import { NamedDialog, DialogComponent, PageService } from '@tytapp/common';
import { UserService } from '@tytapp/user';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { ApiUserAuthToken, UsersApi } from '@tytapp/api';

@NamedDialog('confirm-account')
@Component({
    selector: 'tyt-confirm-account',
    templateUrl: './confirm-account.component.html',
    styleUrls: ['./confirm-account.component.scss']
})
export class ConfirmAccountComponent extends DialogComponent {

    constructor(
        private userService: UserService,
        pageService: PageService,
        private userApi: UsersApi
    ) {
        super(pageService);
    }

    async init(params) {
        let userToken: ApiUserAuthToken;

        try {
            userToken = <ApiUserAuthToken>await this.userApi.confirmEmail({ token: params.token }).toPromise();
            this.success = true;
            this.userService.completeLogin(userToken, userToken.token, true, () => {
                this.router.navigate(['/account']);
                this.shell.showDialog(MessageDialogComponent, 'Confirmed', "Your account has been successfully confirmed, and you are now logged in.");
            });

        } catch (e) {
            this.error = true;
            this.errorMessage = "Failed to confirm your account: " + (e.message || e.error);
            this.router.navigate(['/']);
        }
    }

    public resend: boolean = false;
    public resending: boolean = false;
    public resent: boolean = false;
    public email: string = "";

    async sendConfirmationMail(email: string) {
        this.resending = true;

        await this.userApi.sendConfirmationEmail({ email }).toPromise();
        this.resent = true;
    }

    public success: boolean = false;

}
